<template>
	<div style="height: 100%">
		<div class="buttonBox">
			<div style="margin-left: -4px;">
				<div class="chooseButton searchButton" @click="add" v-if="MenuRoleList.indexOf('46')>=0"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}</div>
				<div class="chooseButton searchButton" @click="edit" v-if="MenuRoleList.indexOf('47')>=0"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}</div>
				<div class="chooseButton deleteButton" @click="remove" v-if="MenuRoleList.indexOf('48')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
			</div>
		</div>
		<div class="tableMin">
			<el-table :empty-text="$t('label_357')" :data="tableData" @current-change="tableCurrentChange" ref="singleTable" highlight-current-row border
			 style="width: 100%;margin: 10px 0;" :height="tableHeight" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
				<el-table-column :label="$t('label_369') + '.'" header-align="center" align="center" type="index" width="50">
				</el-table-column>
				<el-table-column :label="$t('label_2')">
					<template slot-scope="scope">
						<div @dblclick='nameClick(scope.row)'>
							{{scope.row.name}}<br>
							{{scope.row.code}}<br>
							{{scope.row.duty}}
						</div>
					</template>
				</el-table-column>
<!--				<el-table-column :label="$t('label_724')">-->
<!--					<template slot-scope="scope">-->
<!--						{{scope.row.contactNames}}-->
<!--						<div class='contactRow'><img src="../../../assets/img/phone.png"><span>{{scope.row.phone}}</span>-->
<!--						</div>-->
<!--						<div class='contactRow'><img src="../../../assets/img/fax.png"><span>{{scope.row.fax}}</span>-->
<!--						</div>-->
<!--						<div class='contactRow'><img src="../../../assets/img/mail.png"><span>{{scope.row.email}}</span>-->
<!--						</div>-->
<!--					</template>-->
<!--				</el-table-column>-->
				<el-table-column :label="$t('label_412')" align="center">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.state" :active-value='1' :inactive-value='0' :active-text="$t('label_10')" :inactive-text="$t('label_6')"
						 active-color="#3fb393" inactive-color="#ff3300" @change="stateChange(scope.row)" :disabled="!(MenuRoleList.indexOf('46')>=0||MenuRoleList.indexOf('47')>=0||MenuRoleList.indexOf('48')>=0)">
						</el-switch>
					</template>
				</el-table-column>
        <!--el-table-column v-if="version != 1" :label="$t('label_929')" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.checkAllOrNot" :active-value='1' :inactive-value='0' :active-text="$t('label_471')" :inactive-text="$t('label_474')"
                       active-color="#3fb393" inactive-color="#ff3300" @change="checkAllOrNotChange(scope.row)" :disabled="!(MenuRoleList.indexOf('46')>=0||MenuRoleList.indexOf('47')>=0||MenuRoleList.indexOf('48')>=0)">
            </el-switch>
          </template>
        </el-table-column-->
				<el-table-column :label="$t('label_501')" align="center">
					<template slot-scope="scope">
						<el-button @click="moveUp(scope.row, scope.$index)" :disabled="scope.$index === 0" type="text" size="small" style="font-size: 20px"><i
							 class="el-icon-arrow-up"></i>
						</el-button>
						<el-button @click="moveDown(scope.row, scope.$index)" :disabled="arrowDisabled(scope.$index)" type="text" size="small"
						 style="font-size: 20px"><i class="el-icon-arrow-down"></i>
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-dialog v-loading="saveLoading" :visible.sync="dialogVisible" :title="dialogTitle" :before-close="dialogClose" append-to-body v-dialogDrag
		 :close-on-click-modal='false' width="800px" top="5%" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<el-row class="dialogMes">
					<el-col :span="1"></el-col>
					<el-col :span="3">{{$t('label_720')}}</el-col>
					<el-col :span="20">
						<div class="treeNoChoose">
							<div class="selectSpot2">
								<el-tree :load="loadChild" @check-change="handleCheckChange" v-if="showTree" ref="tree" :props="treeProps"
								 show-checkbox check-strictly lazy :accordion='true' node-key="id" :default-expanded-keys="expandedKeys"
								 :render-after-expand='false'>
									<div class="custom-tree-node" slot-scope="{node,data}">
										<div class="title" style="width:250px;position:relative;display: flex">
											<p style="width: 150px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
												{{data.name}}
											</p>
										</div>
									</div>
								</el-tree>
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row class="dialogMes">
					<el-col :span="1" style='color:#ff0000;text-align: right;padding-right: 5px;'>*</el-col>
					<el-col :span="3">{{$t('label_297')}}</el-col>
					<el-col :span="8">
						<el-input v-model="formModel.name" clearable></el-input>
					</el-col>
					<el-col :span="1"></el-col>
					<el-col :span="3">{{$t('label_722')}}</el-col>
					<el-col :span="8">
						<el-input v-model="formModel.code" clearable></el-input>
					</el-col>
				</el-row>
<!--				<el-row class="dialogMes">-->
<!--					<el-col :span="1"></el-col>-->
<!--					<el-col :span="3">{{$t('label_724')}}</el-col>-->
<!--					<el-col :span="8">-->
<!--						<el-tag v-for="(item, index) in formModel.contactNames" :key="index" @close="contactClose(item)" closable effect="plain"-->
<!--						 color='#ffffff' :disable-transitions="true">-->
<!--							{{item}}-->
<!--						</el-tag>-->
<!--						<el-autocomplete :fetch-suggestions="querySearchAsync" @select="handleSelect" value-key='fullName' v-model="inputValue"-->
<!--						 v-if="inputVisible" ref="saveTagInput" :placeholder="$t('input_46')" :trigger-on-focus="false" size="small">-->
<!--						</el-autocomplete>-->
<!--						<el-button v-else @click="showInput" size="small">+ {{$t('btn_14')}}</el-button>-->
<!--					</el-col>-->
<!--					<el-col :span="1"></el-col>-->
<!--					<el-col :span="3">{{$t('label_726')}}</el-col>-->
<!--					<el-col :span="8">-->
<!--						<el-input v-model="formModel.email" clearable></el-input>-->
<!--					</el-col>-->
<!--				</el-row>-->
<!--				<el-row class="dialogMes">-->
<!--					<el-col :span="1"></el-col>-->
<!--					<el-col :span="3">{{$t('label_729')}}</el-col>-->
<!--					<el-col :span="8">-->
<!--						<el-input v-model="formModel.phone" clearable></el-input>-->
<!--					</el-col>-->
<!--					<el-col :span="1"></el-col>-->
<!--					<el-col :span="3">{{$t('label_324')}}</el-col>-->
<!--					<el-col :span="8">-->
<!--						<el-input v-model="formModel.fax" clearable></el-input>-->
<!--					</el-col>-->
<!--				</el-row>-->
				<el-row class="dialogMes">
					<el-col :span="1"></el-col>
					<el-col :span="3">{{$t('label_733')}}</el-col>
					<el-col :span="20">
						<el-input v-model="formModel.duty" type="textarea" :rows="2" clearable>
						</el-input>
					</el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<div @click="save" class="chooseButton sendButton">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog :visible.sync="viewDialogVisible" :title="$t('label_200')" append-to-body custom-class="dialogBox">
			<div style='width:90%;margin-left:5%;'>
				<span style='font-size: 20px;'><span style='margin-right:10px;font-weight: 600;'>{{viewModel.name}}</span>{{viewModel.code}}</span>
				<div class='viewDialogTable'>
					<label>{{$t('label_720')}}</label>
					<div>{{parentName}}</div>
					<label>{{$t('label_569')}}</label>
					<div>{{viewModel.contactNames}}
						<img src="../../../assets/img/phone.png">{{viewModel.phone}}
						<img src="../../../assets/img/fax.png">{{viewModel.fax}}
						<img src="../../../assets/img/mail.png">{{viewModel.email}}
					</div>
					<label>{{$t('label_733')}}</label>
					<div>{{viewModel.duty}}</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import utils from '@/utils/utils';
	import organizationTabJs from "@/assets/js/system/organizationTab.js";
	import userJs from "@/assets/js/system/user.js";
	import file from "@/assets/js/file/file.js";
	export default {
		name: "organizationTab",
		components: {},
		data() {
			return {
			  saveLoading: false,
				nodeId: '',
				//table
				tableData: [],
				MenuRoleList: [],
				currentRow: {},
				tableHeight: 0,
				//edit dialog
				dialogVisible: false,
				dialogTitle: this.$t('label_193'),
				formModel: {
					parentId: '',
					name: "",
					code: '',
					email: "",
					phone: "",
					fax: '',
					duty: '',
					contactNames: [],
					contactIds: [],
          state: 1,
          valid: 0
				},
				treeProps: {
					label: 'name',
				},
				expandedKeys: [],
				showTree: true,
				inputVisible: false,
				inputValue: '',
				//viewDialog
				viewDialogVisible: false,
				viewModel: {
					name: "",
					code: '',
					email: "",
					phone: "",
					fax: '',
					duty: '',
					contactNames: '',
				},
				parentName: '',
			}
		},
		methods: {
			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},
			contactClose(contactName) {
				let index = this.formModel.contactNames.indexOf(contactName);
				this.formModel.contactNames.splice(index, 1);
				this.formModel.contactIds.splice(index, 1);
			},
			handleSelect(item) {
				if (this.formModel.contactIds == null) {
					this.formModel.contactNames = [item.fullName];
					this.formModel.contactIds = [item.id];
				} else {
					this.formModel.contactNames.push(item.fullName);
					this.formModel.contactIds.push(item.id);
				}
				this.formModel.email = item.email;
				this.formModel.phone = item.mobile;
				this.inputVisible = false;
				this.inputValue = '';
			},
			querySearchAsync(queryString, cb) {
				userJs.getByName({
					name: queryString
				}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data);
					}
				}).catch((response) => {
					console.log(response)
				});
			},
			loadChild(node, resolve) {
				if (node.level === 0) {
					let child = this.getChildren(0);
					child.then((res) => {
						resolve(res);
					});
				} else {
					let child = this.getChildren(node.data.id);
					child.then((res) => {
						if (res == "") {
							return resolve([]);
						} else {
							resolve(res);
						}
					});
				}
			},
			async getChildren(pid) {
				let childArr = [];
				await organizationTabJs.getChildren({
					pid: pid
				}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						childArr = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				return childArr;
			},
			handleCheckChange(data, checked, indeterminate) {
				if (checked) {
					this.formModel.parentId = data.id;
				} else {
					this.formModel.parentId = '';
				}
			},
			reloadTree() {
				this.showTree = false;
				this.$nextTick(function() {
					this.showTree = true;
				})
			},

			tableCurrentChange(row) {
				this.currentRow = row;
			},
			arrowDisabled(index) {
				if (index === this.tableData.length - 1) return true;
				else return false;
			},
			nameClick(item) {
				this.viewModel.name = item.name;
				this.viewModel.code = item.code;
				this.viewModel.email = item.email;
				this.viewModel.duty = item.duty;
				this.viewModel.phone = item.phone;
				this.viewModel.fax = item.fax;
				this.viewModel.contactNames = item.contactNames;
				organizationTabJs.getParent({
					id: item.id
				}).then((response) => {
					if (response.data.code == 1) {
						this.parentName = response.data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				this.viewDialogVisible = true;
			},
			stateChange(item) {
				organizationTabJs.updateState({
					id: item.id,
					state: item.state
				}).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.list();
						this.$emit('reload');
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			moveUp(item, index) {
				organizationTabJs.sort({
					id: item.id,
					sort: item.sequence,
					id2: this.tableData[index - 1].id,
					sort2: this.tableData[index - 1].sequence
				}).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.list();
						this.$emit('reload');
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			moveDown(item, index) {
				organizationTabJs.sort({
					id: item.id,
					sort: item.sequence,
					id2: this.tableData[index + 1].id,
					sort2: this.tableData[index + 1].sequence
				}).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.list();
						this.$emit('reload');
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			remove() {
				if (Object.keys(this.currentRow).length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						organizationTabJs.remove({
							id: this.currentRow.id
						}).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.list();
								this.$emit('reload');
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			add() {
				this.formModel.parentId = this.nodeId;
				this.dialogVisible = true;
				this.dialogTitle = this.$t('label_193');
				this.showTree = false;
				this.$nextTick(function() {
					this.showTree = true;
					this.$nextTick(_ => {
						this.$refs.tree.setCurrentKey(this.nodeId);
						this.$refs.tree.setCheckedKeys([this.nodeId]);
					});
				})
			},
			edit() {
				if (Object.keys(this.currentRow).length > 0) {
					this.dialogTitle = this.$t('label_196');
					this.formModel = {
						id: this.currentRow.id,
						parentId: this.currentRow.parentId,
						name: this.currentRow.name,
						code: this.currentRow.code,
						email: this.currentRow.email,
						phone: this.currentRow.phone,
						fax: this.currentRow.fax,
						duty: this.currentRow.duty,
						contactNames: this.currentRow.contactNames,
						contactIds: this.currentRow.contactIds,
					};
					if (this.currentRow.contactIds != null) {
						this.formModel.contactIds = this.currentRow.contactIds.split(',');
						this.formModel.contactNames = this.currentRow.contactNames.split(',');
					}
					this.dialogVisible = true;
					this.$nextTick(_ => {
						this.expandedKeys.push(this.currentRow.parentId);
						this.$refs.tree.setCurrentKey(this.currentRow.parentId);
						this.$refs.tree.setCheckedKeys([this.currentRow.parentId]);
					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			dialogClose() {
				this.formModel = {
					parentId: '',
					name: "",
					code: '',
					email: "",
					phone: "",
					fax: '',
					duty: '',
					contactNames: [],
					contactIds: [],
				};
				this.$refs.tree.setCheckedKeys([]);
				this.dialogVisible = false;
			},
			save() {
			  this.saveLoading = true;
				if (this.$refs.tree.getCheckedKeys().length > 1) {
					utils.messageAlert(this.$t('msg_149'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.formModel.name == '') {
					utils.messageAlert(this.$t('msg_30'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				for (let i = 0; i < this.tableData.length; i++) {
					if (this.tableData[i].name == this.formModel.name) {
						if (this.dialogTitle == this.$t('label_193')) {
							utils.messageAlert(this.$t('msg_150'), this.$t('label_358'), this.$t('label_100'));
              this.saveLoading = false;
							return;
						}
					}
				}
				if (this.inputValue != '') {
					utils.messageAlert(this.$t('label_724') + "[" + this.inputValue + "]" + this.$t('msg_32'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if(this.$refs.tree.getCheckedKeys().length ==1){
					this.formModel.parentId=this.$refs.tree.getCheckedKeys()[0]
				}
				this.formModel.state = 1;
				this.formModel.valid = 0;
				if (this.dialogTitle == this.$t('label_193')) {
					organizationTabJs.add(this.formModel).then((response) => {
						if (response.data.code == "1") {
							this.$emit('reload');
							this.dialogVisible = false;
							// utils.messageAlert(this.$t('msg_18'), this.$t('label_358'), this.$t('label_100'));
              this.$message.success(this.$t('msg_18'))
              this.formModel = {
								parentId: '',
								name: "",
								code: '',
								email: "",
								phone: "",
								fax: '',
								duty: '',
								contactNames: [],
								contactIds: [],
							};
							this.$refs.tree.setCheckedKeys([]);
							this.list();
							this.reloadTree();
						} else {
							utils.messageAlert(response.data.message, this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				} else {
					organizationTabJs.edit(this.formModel).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.$emit('reload');
							this.dialogVisible = false;
							// utils.messageAlert(this.$t('msg_19'), this.$t('label_358'), this.$t('label_100'));
              this.$message.success(this.$t('msg_19'));
							this.formModel = {
								parentId: '',
								name: "",
								code: '',
								email: "",
								phone: "",
								fax: '',
								duty: '',
								contactNames: [],
								contactIds: [],
							};
							this.$refs.tree.setCheckedKeys([]);
							this.list();
							this.reloadTree();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				}
			},
			list() {
				organizationTabJs.getChildren({
					pid: this.nodeId
				}).then((response) => {
					if (response.data.code == 1) {
						this.tableData = response.data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			setNodeId(id) {
				this.nodeId = id;
				this.expandedKeys.push(this.nodeId);
				this.tableHeight = document.querySelector('.el-tabs__content').clientHeight - 54;
			},
      checkAllOrNotChange(row) {
        organizationTabJs.updateCheckAllOrNot({
          id: row.id,
          flag: row.checkAllOrNot
        }).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        });
      }
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>
<style scoped>
	.el-col {
		line-height: 40px;
	}

	.contactRow {
		height: 20px;
		margin-top: 3px;
		line-height: 20px;
		vertical-align: middle;
	}

	.contactRow img {
		height: 90%;
		line-height: 18px;
		vertical-align: middle;
	}

	.contactRow span {
		margin-left: 5px;
		line-height: 20px;
		vertical-align: middle;
	}

	.treeNoChoose .selectSpot2 {
		height: 100%;
	}

	.viewDialogTable {
		margin-top: 10px;
		border: 1px solid #aaaaaa;
	}

	.viewDialogTable label {
		display: block;
		width: 100%;
		padding: 6px;
		border-bottom: 1px solid #aaaaaa;
		background-color: #ebebeb;
		font-weight: 600;
	}

	.viewDialogTable div {
		width: 100%;
		padding: 6px;
	}

	.viewDialogTable img {
		height: 18px;
		line-height: 18px;
		margin-left: 30px;
		margin-right: 6px;
		vertical-align: middle;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/organizationTab.vue